import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex"></div>
    <div>
      <div className="box-form">
        <ul className="buttom_menu">
          <li>
            <a onClick={props.handleModal}>
              {"Crear nueva solicitud"}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/flow_applicant_detail/buttons.jsx